// ============================================================
// Regole sulle origini del canale del token studente (WP-13e/13f)
// ============================================================
// Pezzo condiviso fra il ponte postMessage (studentTokenBridge) e il caricamento a runtime dell'elenco
// (trustedOriginsRuntime). Qui stanno i DIVIETI che restano nel codice e non dipendono da nessuna
// configurazione: un host di contenuti di terzi non e' mai attendibile, nemmeno se compare in un elenco.
// ============================================================

/**
 * Host che servono contenuti di terzi (cataloghi caricati da utenti, HTML esterno): non sono mai app TL4K
 * attendibili, nemmeno se stanno sotto il dominio TL4K. Vietata la prima etichetta del nome host che CONTIENE una
 * di queste parole (storage, storage-eu, cdn-uploads, usercontent2, content-cdn...). Stessa regola nella copia
 * del collaboration-service (src/runtimeTrustedOrigins.ts): tenerle identiche.
 */
export const UNTRUSTED_HOST_LABELS = ["storage", "user-content", "usercontent", "uploads", "content"];

export function isUntrustedContentHost(host: string): boolean {
  const first = host.toLowerCase().split(".")[0];
  return UNTRUSTED_HOST_LABELS.some((w) => first.includes(w));
}

/**
 * Normalizza un elenco di origini (stringa separata da virgola o array): solo origini http(s) esatte,
 * senza credenziali, mai host di contenuti di terzi. Voci non valide, `null` (sandbox) e schemi diversi
 * (file:, data:, javascript:) sono scartati. Senza duplicati.
 */
export function parseTrustedOrigins(raw: string | string[] | undefined | null): string[] {
  const list = Array.isArray(raw) ? raw : String(raw ?? "").split(",");
  const out: string[] = [];
  for (const item of list) {
    if (typeof item !== "string") continue;
    const s = item.trim();
    if (!s) continue;
    try {
      const u = new URL(s);
      if (u.protocol !== "http:" && u.protocol !== "https:") continue;
      if (u.username || u.password) continue;
      if (isUntrustedContentHost(u.hostname)) continue;
      if (!out.includes(u.origin)) out.push(u.origin);
    } catch {
      // voce non valida: ignorata
    }
  }
  return out;
}

/** Host (minuscolo) di un'origine, "" se non valida. */
export function hostOfOrigin(origin: string): string {
  try {
    return new URL(origin).hostname.toLowerCase();
  } catch {
    return "";
  }
}

const warned = new Set<string>();
/** Un solo console.warn per chiave e per pagina. Mai il token nei messaggi. */
export function warnOnce(key: string, message: string): void {
  if (warned.has(key)) return;
  warned.add(key);
  try {
    console.warn(message);
  } catch {
    // console assente
  }
}

/** Solo test. */
export function __resetWarnOnceForTests(): void {
  warned.clear();
}
